import {observer} from 'mobx-react-lite';
import type {ReactNode} from 'react';
import type {StyleProp, ViewProps, ViewStyle} from 'react-native';
import {StyleSheet, View} from 'react-native';

export type FixedWidthRowViewProps = {
  children?: ReactNode;
  innerStyle?: StyleProp<ViewStyle>;
} & ViewProps;

export default observer(function FixedWidthRowView(
  props: FixedWidthRowViewProps,
) {
  const {children, innerStyle, style, ...rest} = props;
  return (
    <View style={[layoutStyles.root, style]} {...rest}>
      <View style={[layoutStyles.fixed, innerStyle]}>{children}</View>
    </View>
  );
});

const layoutStyles = StyleSheet.create({
  root: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'stretch',
  },
  fixed: {
    marginHorizontal: 16,
    maxWidth: 340,
    flexGrow: 1,
    flexShrink: 1,
  },
});
